<tr [formGroup]="detalleFormGroup" #localDetalleForm="ngForm">
    <td>{{detalleNumero}}</td>
    <td WIDTH="12%">
        <div class="form-group">

            <div class="row">

                <div class="col-12" style="overflow: visible;">
                    <input type="text" class="form-control" name="codigo" formControlName="codigo" (blur)="onSubmit()">

                    <!-- <ng-select
                        formControlName="codigo"
                        [items]="searchCatalog"
                        [selectOnTab]="true"
                        [loading]="searchLoading"
                        bindLabel="codigo"
                        placeholder="Ingrese código dte"
                        (change)="refreshItemDetail($event)"
                        (search)="searchItem($event,'codigo')"
                        notFoundText="Sin resultado"
                        ></ng-select> -->

                </div>
            </div>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.codigo.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.codigo.errors?.required">Campo Requerido</div>
            </div>
        </div>
    </td>

    <td WIDTH="14%">
        <div class="form-group">
            <input type="text" class="form-control" name="nombreItem" formControlName="nombreItem" (blur)="onSubmit()">
            <!-- <ng-select
                    formControlName="nombreItem"
                    [items]="searchCatalog"
                    [selectOnTab]="true"
                    [loading]="searchLoading"
                    bindLabel="nombre"
                    placeholder="Ingrese nombre dte"
                    (change)="refreshItemDetail($event)"
                    (search)="searchItem($event,'nombre')"
                    notFoundText="Sin resultado"
                ></ng-select> -->
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.nombreItem.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.nombreItem.errors?.required">Campo Requerido</div>
            </div>
            <div class="row mt-2" *ngIf="detalleFormGroup.controls.haveDescripcion.value && showingDetails">
                <div class="col-12 mt-2 pt-2" style="overflow: visible;">
                    <textarea type="text" class="form-control" name="descripcion" formControlName="descripcion"
                        (blur)="onSubmit()" rows="2" cols="90" style="overflow: visible; width: 136%;"></textarea>
                    <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descripcion.invalid"
                        class="text-danger">
                        <div *ngIf="detalleFormGroup.controls.descripcion.errors?.required">Campo Requerido</div>
                    </div>
                </div>
            </div>
        </div>
    </td>

    <td *ngIf="showingDetails">
        <div class="form-group">
            <div class="row pl-5 mb-4">
                <div class="ml-5">
                    <input type="checkbox" class="form-check-input" name="haveDescripcion"
                        formControlName="haveDescripcion" (change)="changeHaveDescripcion($event)" (blur)="onSubmit()">
                </div>
            </div>


        </div>
    </td>

    <td>
        <div class="form-group">
            <input type="number" class="form-control" min="1" name="cantidad" formControlName="cantidad"
                (blur)="onSubmit()">
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.cantidad.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
            </div>
        </div>
    </td>
    <td WIDTH="12%">
        <div class="form-group">
            <input type="number" class="form-control"  name="precioUnitario" formControlName="precioUnitario"
                (blur)="onSubmit()">
            <div class="clp-equivalent text-right mt-3" *ngIf="opciones.tipoMoneda!='CLP'">

                <div class="float-left">
                    CLP
                </div>
                <div class="float right">
                    {{this.subPrice | number:'1.0-2':'es'}}
                </div>
            </div>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.precioUnitario.invalid"
                class="text-danger">
                <div *ngIf="detalleFormGroup.controls.precioUnitario.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.precioUnitario.errors?.PositiveNumber">Número debe ser positivo
                </div>
            </div>
        </div>
    </td>
    <td>
        <div class="form-group">
            <input type="number" class="form-control" name="descuento" formControlName="descuento"
                (blur)="onSubmit()">
            <div class="clp-equivalent text-right mt-3" *ngIf="opciones.tipoMoneda!='CLP'">
                <div class="float-left">
                    CLP
                </div>
                <div class="float-right">
                    {{this.subDiscount | number:'1.0-2':'es'}}
                </div>
            </div>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descuento.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.descuento.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
            </div>
        </div>
    </td>
    <td>
        <div class="form-group">
            <input type="number" class="form-control"  name="recargo" formControlName="recargo"
                (blur)="onSubmit()">
            <div class="clp-equivalent text-right mt-3" *ngIf="opciones.tipoMoneda!='CLP'">
                <div class="float-left">
                    CLP
                </div>
                <div class="float-right">
                    {{this.subRecharge | number:'1.0-2':'es'}}
                </div>
            </div>
            <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.recargo.invalid" class="text-danger">
                <div *ngIf="detalleFormGroup.controls.recargo.errors?.required">Campo Requerido</div>
                <div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
            </div>
        </div>
    </td>
    <td class="ml-5 text-center">
        <div class="form-group ml-5">
            <input type="checkbox" class="form-check-input" name="exento" formControlName="exento" (blur)="onSubmit()">
        </div>
    </td>
    <!-- <td WIDTH="2%"*ngIf="currentInvoiceType==3">
            <div class="form-group ml-2" style="max-width:50px;">
                <div class="row mb-5" style="width:30%">
                    <div class="col-12">
                        <input type="checkbox" class="ml-0 form-check-input" name="haveRetencion" formControlName="haveRetencion" (change)="changeRetencionInput($event)">
                    </div>
                </div>

                <div class="row pt-5" *ngIf="showRetencionPercent">
                    <div class="col-12 pl-0">
                        <input type="number" min="0" [max]="porcentajeIva*100" class="form-control" name="retencionPorcentaje" formControlName="retencionPorcentaje" (blur)="onSubmit()">
                        <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.retencionPorcentaje.invalid" class="text-danger">
                            <div *ngIf="detalleFormGroup.controls.retencionPorcentaje.errors?.numberIsHigher" class="unbreakable-words">Excede máximo {{porcentajeIva*100}}%</div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5 mx-0" *ngIf="showRetencionPercent" style="overflow: visible;">
                    <div class="col-12 pl-0">
                        <ng-select
                            formControlName="retencionTipo"
                            [items]="retencionesSource"
                            [selectOnTab]="true"
                            bindLabel="nombre"
                            placeholder="Seleccione retención"
                            class="overflow-select"
                            (change)="getRetencionChanges($event)"
                        ></ng-select>
                    </div>
                    
                    <div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.retencionTipo.invalid" class="text-danger">
                        <div *ngIf="detalleFormGroup.controls.retencionTipo.errors?.required" class="unbreakable-words">Campo requerido</div>
                    </div>
                </div>
            </div>
        </td> -->
    <td WIDTH="12%">
        <div class="float-right" style="width:100%">
            <div class="alter-equivalent text-right mb-5 pt-2" *ngIf="opciones.tipoMoneda != 'CLP'">
                <div class="mb-5 pt-2">

                    <div class="float-right">
                        {{totalForeign | number:'1.0-2':'es'}}

                    </div>
                </div>
                <div class="text-right mt-5 pt-5 pt-1">
                    <div class="float-left mt-1">
                        CLP
                    </div>
                    <div class="float-right mt-1">
                        {{detalleDte.total | number:'1.0-2':'es'}}
                    </div>
                </div>
            </div>
            <!-- <input type="number" class="form-control" name="subtotal" formControlName="subtotal" (blur)="onSubmit()"> -->
            <div class="text-right" *ngIf="opciones.tipoMoneda == 'CLP'">


                <div class="float-right">
                    {{detalleDte.total | number:'1.0-2':'es'}}
                </div>
            </div>
        </div>
    </td>
    <td>
        <button class="btn btn-danger" (click)="deleteItem()">
            <i class="flaticon-delete"></i>
        </button>
    </td>

</tr>
<swal #currentSwal title="Operación" text="Operación realizada" icon="info" style="z-index: 900000 !important;"></swal>